import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API, useApp } from "@/AppContext";
import { Users, X, ArrowRight } from "@phosphor-icons/react";

export default function ReviewNudgeBanner() {
  const { user, authHeaders, lang } = useApp();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [dismissed, setDismissed] = useState(false);
  const es = lang === "es";

  useEffect(() => {
    if (!user || user.role !== "hirer") return;
    let active = true;
    axios
      .get(`${API}/hirer/review-nudge`, { headers: authHeaders() })
      .then((r) => {
        if (active && r.data?.show) {
          setData(r.data);
          axios.post(`${API}/hirer/review-nudge/seen`, {}, { headers: authHeaders() }).catch(() => {});
        }
      })
      .catch(() => {});
    return () => { active = false; };
  }, [user]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!data || dismissed) return null;
  const { total, top, link } = data;
  const single = data.jobs?.length === 1;
  const message = single
    ? (es
        ? `${top.title} tiene ${top.count} postulante${top.count !== 1 ? "s" : ""} sin revisar — los mejores se contratan rápido.`
        : `${top.title} has ${top.count} new applicant${top.count !== 1 ? "s" : ""} waiting — the best workers get hired fast.`)
    : (es
        ? `Tienes ${total} postulantes nuevos en tus trabajos activos — revísalos ahora.`
        : `You have ${total} new applicants across your active jobs — review them now.`);

  return (
    <div
      className="w-full bg-[#FF7A1A]/12 border-b border-[#FF7A1A]/35 px-4 py-2.5"
      data-testid="review-nudge-banner"
    >
      <div className="max-w-6xl mx-auto flex items-center gap-3">
        <div className="flex items-center justify-center w-7 h-7 rounded-full bg-[#FF7A1A]/20 flex-shrink-0">
          <Users size={16} weight="fill" className="text-[#FF7A1A]" />
        </div>
        <p className="text-sm text-white flex-1 leading-snug">
          <span className="mr-1">👀</span>{message}
        </p>
        <button
          onClick={() => { setDismissed(true); navigate(link); }}
          className="btn-notch-primary !text-[11px] !py-1.5 !px-3 flex-shrink-0"
          data-testid="review-nudge-cta"
        >
          {es ? "Revisar" : "Review applicants"} <ArrowRight size={13} weight="bold" />
        </button>
        <button
          onClick={() => setDismissed(true)}
          className="text-zinc-400 hover:text-white flex-shrink-0 p-1"
          aria-label={es ? "Cerrar" : "Dismiss"}
          data-testid="review-nudge-dismiss"
        >
          <X size={16} weight="bold" />
        </button>
      </div>
    </div>
  );
}
